import { render } from "./FrontDeskIndex.vue?vue&type=template&id=57fa066e&scoped=true"
import script from "./FrontDeskIndex.vue?vue&type=script&lang=js"
export * from "./FrontDeskIndex.vue?vue&type=script&lang=js"

import "./FrontDeskIndex.vue?vue&type=style&index=0&id=57fa066e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57fa066e"]])

export default __exports__